import { render, staticRenderFns } from "./consumer.vue?vue&type=template&id=dbd369a4&scoped=true&"
import script from "./consumer.vue?vue&type=script&lang=js&"
export * from "./consumer.vue?vue&type=script&lang=js&"
import style0 from "./consumer.vue?vue&type=style&index=0&id=dbd369a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd369a4",
  null
  
)

export default component.exports